import React from 'react';
import PropTypes from 'prop-types';
import If from '../../utils/react-if';
import * as SharedStyle from '../../shared-style';

var STYLE_LINE = {
  fill: "#0096fd",
  stroke: "#0096fd"
};

var STYLE_CIRCLE = {
  fill: "#0096fd",
  stroke: "#0096fd",
  cursor: "ew-resize"
};

var STYLE_CIRCLE2 = {
  fill: "none",
  stroke: "#0096fd",
  cursor: "ew-resize"
};

export default function Item(_ref) {
  var layer = _ref.layer,
      item = _ref.item,
      scene = _ref.scene,
      catalog = _ref.catalog,
      isDesktop = _ref.isDesktop;
  var x = item.x,
      y = item.y,
      rotation = item.rotation;


  var elevationItems = [];
  var currentlayerElevationItems = [];
  var floorsArr = [];
  var activeFloors = [];
  var minFloorID = '';
  var hasElevationItemsOnDifferentFloors = false;

  // let deltaX = 0;
  // let deltaY = 0;

  if (item.floorID) {
    var layers = scene.get('layers');

    if (layers) {
      layers.forEach(function (currentLayer) {
        var layerItems = currentLayer.get('items').toJS();

        if (layerItems) {
          for (var item in layerItems) {
            var itemObj = layerItems[item];

            if (itemObj && (itemObj.name === 'Elevation Sign' || itemObj.type === 'elevation-sign')) {
              var currentLayerId = currentLayer.get('id');

              if (currentLayerId === layer.id) {
                currentlayerElevationItems.push(itemObj);
              } else {
                elevationItems.push(itemObj);
              }
            }
          }
        }
      });

      if (currentlayerElevationItems.length > 0 || elevationItems.length > 0) {
        var allElevationItems = currentlayerElevationItems.concat(elevationItems);

        var _loop = function _loop(elItem) {
          var elevationItemOnDiffFloor = allElevationItems.find(function (i) {
            return i.floorID !== elItem.floorID;
          });

          if (elevationItemOnDiffFloor) {
            hasElevationItemsOnDifferentFloors = true;
            return 'break';
          }
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = allElevationItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var elItem = _step.value;

            var _ret = _loop(elItem);

            if (_ret === 'break') break;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      //console.log(hasElevationItemsOnDifferentFloors);

      if (hasElevationItemsOnDifferentFloors) {
        var floors = scene.get('floors').toJS();

        if (floors) {
          for (var floor in floors) {
            floorsArr.push(floors[floor]);
          }
        }

        if (floorsArr.length > 0) {
          floorsArr.forEach(function (floor) {
            var found = elevationItems.find(function (i) {
              return i.floorID === floor.id;
            });

            if (!found) {
              found = currentlayerElevationItems.find(function (i) {
                return i.floorID === floor.id;
              });
            }

            if (found) {
              activeFloors.push(floor);
            }
          });

          if (activeFloors.length > 0) {
            var minFloor = activeFloors.reduce(function (prev, current) {
              return prev.elevation < current.elevation ? prev : current;
            });

            if (minFloor) {
              minFloorID = minFloor.id;
            }
          }
        }

        if (minFloorID) {
          var itemFloorId = item.floorID;
          var currentElevationItem = currentlayerElevationItems.find(function (i) {
            return i.floorID === itemFloorId;
          });

          if (!currentElevationItem) {
            currentElevationItem = elevationItems.find(function (i) {
              return i.floorID === itemFloorId;
            });
          }

          var minFloorElevationItem = currentlayerElevationItems.find(function (i) {
            return i.floorID === minFloorID;
          });

          if (!minFloorElevationItem) {
            minFloorElevationItem = elevationItems.find(function (i) {
              return i.floorID === minFloorID;
            });
          }

          // if (minFloorElevationItem && currentElevationItem) {
          //   if (minFloorID !== itemFloorId) {
          //     deltaX = currentElevationItem.x - minFloorElevationItem.x;
          //     deltaY = currentElevationItem.y - minFloorElevationItem.y;
          //   }
          // }

          var deltaX = x - currentElevationItem.x;
          var deltaY = y - currentElevationItem.y;

          x = minFloorElevationItem.x + deltaX;
          y = minFloorElevationItem.y + deltaY;
        }
      }
    }
  }

  if (!minFloorID) {
    x = x + y / 1.8 - 440;
    y = y + 50;
  } else {
    x = x + y / 1.8 - 440;
    y = y + 90;
  }

  var renderedItem = catalog.getElement(item.type).renderAxonomertic ? catalog.getElement(item.type).renderAxonomertic(item, layer, scene) : null;

  //let layerAltitude = layer.altitude;
  var itemAltitude = item.getIn(['properties', 'altitude', 'length']);

  var floorID = item.floorID;
  var floorAltitude = 0;

  if (floorID) {
    floorAltitude = scene.getIn(['floors', floorID, 'elevation']);
  }

  if (renderedItem && renderedItem.key === 'no-rotation') {
    rotation = 0;
  }

  itemAltitude = itemAltitude ? itemAltitude : 0;

  //  <g transform={`translate(${-deltaX}, ${floorAltitude + itemAltitude - deltaY})`}>

  return React.createElement(
    'g',
    { transform: 'translate(0, ' + (floorAltitude + itemAltitude) + ')' },
    React.createElement(
      'g',
      {
        'data-element-root': true,
        'data-prototype': item.prototype,
        'data-id': item.id,
        'data-selected': item.selected,
        'data-layer': layer.id,
        style: item.selected ? { cursor: "move" } : {},
        transform: 'translate(' + x + ',' + y + ') rotate(' + rotation + ')' },
      renderedItem
    )
  );
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};